import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from 'src/app/home/home.component';
import { AvailbilityComponent } from './availbility/availbility.component';
import { CruiseDetailsComponent } from './availbility/cruisedetails.component';
import { SSOComponent } from './agentlogin/sso.component';
import { DataResolver } from './services/data-resolve.service';
import { EnquiryComponent } from './templates/enquiry-success.component';
import { BookingReportComponent } from './reports/bookingReport.component';
import { AgentDashBoardComponent } from './agentdashboard/agentdashboard.component';
import { CruiseItineraryComponent } from './reports/cruise-itinerary.component';
import { AdminLoginComponent } from './agentdashboard/adminlogin.component';
import { RemoveCacheComponent } from './remove-cache/remove-cache.component';
import { VoucherComponent } from './templates/cruise-voucher.component';
import { GenericComponent } from './subscription/generic.component';
import { RechargeComponent } from './recharge/recharge.component';
import { RechargeHomeComponent } from './recharge/rechargehome.component';
import { RechargeB2CComponent } from './recharge/rechargeb2c.component';

// import { AdminLoginComponent } from './agentlogin/agentlogin.component';


const routes: Routes = [
  { path: '', component: HomeComponent, resolve: { merchantsetup: DataResolver } },
  { path: 'availbility', component: AvailbilityComponent },
  { path: 'availbility/:searchstring', component: AvailbilityComponent },
  { path: 'autosignin', component: SSOComponent, resolve: { merchantsetup: DataResolver } },
  { path: 'enquiry-success', component: EnquiryComponent },
  { path: 'reports', component: BookingReportComponent },
  { path: 'dashboard', component: AgentDashBoardComponent },
  { path: 'cruise/itinerary/:txId/:status', component: CruiseItineraryComponent },
  { path: 'login', component: AdminLoginComponent },
  { path: 'removecache', component: RemoveCacheComponent },
  { path: 'cruise/voucher/:txId/:status', component: VoucherComponent },
  { path: ':searchstring', component: AvailbilityComponent },
  { path: ':searchstring/:destination', component: AvailbilityComponent },
  { path: 'cruise-details', component: CruiseDetailsComponent },
  { path: 'cruise-details/:cruise/:searchstring', component: CruiseDetailsComponent },
  { path: 'international-sim/activation/recharge', component: RechargeComponent },
  { path: 'international-sim/activation/sim', component: RechargeHomeComponent },
  { path: 'international-sim/activation/recharge-customer/:country', component: RechargeB2CComponent },

  // {
  //   path: 'pax-details', loadChildren: () => import('./pax-details/pax-details.module')
  //     .then(m => m.PaxDetailsModule)
  // },
  {
    path: 'pax-details/traveller/:cruiseData', loadChildren: () => import('./pax-details/pax-details.module')
      .then(m => m.PaxDetailsModule)
  },
  {
    path: 'success', loadChildren: () => import('./bookingConfirmed/booking.module')
      .then(m => m.BookingModule)
  },

  // Multiple Routes Defined
  { path: 'cruise/:param1/:param2/:param3/:param4', component: GenericComponent },
  { path: 'cruise/:param1/:param2/:param3', component: GenericComponent },
  { path: 'cruise/:param1/:param2', component: GenericComponent },
  { path: 'cruise/:param1', component: GenericComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule],
  providers: [DataResolver]
})
export class AppRoutingModule { }
